import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
// Data
import MDButton from "../../components/MDButton";
import buildQuotationTable from "layouts/quotation/data/quotationTableData";
import QuotationEdit from "./edits/QuotationEdit";
import apis from "../../context/api";

function Quotation() {
  const [quotationUpdate, setQuotationUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [quotationData, setQuotationData] = useState({ columns: [], rows: [] });
  const handleCancel = () => {
    setQuotationUpdate(false);
  };
  const quotationUpdated = () => {
    setQuotationUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editCombo = (id) => {
    setId(id);
    setQuotationUpdate(true);
  };
  const convertPIOrder = (id, date) => {
    setQuotationUpdate(false);
    apis
      .convertPi(id, date)
      .then((res) => {
        loadTableData();
      })
      .catch((err) => {
        console.error("Data loading error:", err);
      });
  };

  const loadTableData = async () => {
    try {
      apis
        .getAllQuotation()
        .then((data) => {
          setQuotationData(
            buildQuotationTable(
              data,
              (id) => editCombo(id),
              (id, date) => convertPIOrder(id, date)
            )
          );
        })
        .catch((err) => {
          throw new Error("Can not get Quotations");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {quotationUpdate && (
        <QuotationEdit onSuccess={quotationUpdated} id={id} onCancel={handleCancel} />
      )}
      {!quotationUpdate && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Quotation Table
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        setId(null);
                        setQuotationUpdate(true);
                      }}
                    >
                      Create
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: quotationData.columns, rows: quotationData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Quotation;
